import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {apiClient} from "../connection/BlinkApiClient";
import {Currency} from "../../stem-core/localization/CurrencyStore";
import {field} from "../../stem-core/state/StoreField";

@globalStore
export class UserPreferences extends BaseStore("UserPreferences") {
    @field(Number) userId: number;
    declare defaultCurrencyId: number;
    declare alwaysShowBalance: boolean;
    declare showPaymentAnimation: boolean;

    getDefaultCurrency(): Currency | undefined {
        return Currency.get(this.defaultCurrencyId);
    }

    shouldShowBalanceInline(): boolean {
        return this.alwaysShowBalance;
    }

    shouldShowPaymentAnimation(): boolean {
        return this.showPaymentAnimation;
    }

    static getPreferences(): UserPreferences | undefined {
        return this.all()[0];
    }
}

export async function apiUpdatePreferences(preferences: any = {}): Promise<UserPreferences> {
    const response = await apiClient.post("/preferences/update_user_preferences", preferences);
    return UserPreferences.loadObject(response);
}
